import React from 'react';
import { makeStyles } from '@material-ui/styles';

import TopAppBar from './TopAppBar';
import PanelButtons from './PanelButtons';
import {List, Typography } from '@material-ui/core';
import { priceFormat } from '../hooks/currency';
import Addition from './Addition';
import {useState} from 'react'
import { getTotalPriceVariant } from '../hooks/price';
import { getShortUuid } from '../hooks/uid';
import AdditionCounter from './AdditionCounter';


const useStyles = makeStyles((theme) => ({

  containerPage:{
    display: 'flex',
    flexDirection: 'column', 
    justifyContent: 'flex-start', 
    alignItems: 'center',
    //width: "100vw", 
  },


  containerContent:{
    display: 'flex', 
    flexDirection: 'column', 
    justifyContent: 'center', 
    //backgroundColor: 'blue',
    width: "100%",
    //padding: theme.spacing(2), 
    [theme.breakpoints.up('md')]: {
      width: "40%",
     
    },
  },


  containerList:{
    //backgroundColor: 'blue',
    marginBottom: "10vh",
    padding: theme.spacing(2,1,0,1),
  },


  title: {
    width: "100%",
    padding: theme.spacing(1,2,1,2),

    display: 'flex', 
    flexDirection:'column',
    justifyContent: 'flex-start', 

    [theme.breakpoints.up('md')]: {
     marginTop:  theme.spacing(2),
    },
   
  },


  imageItem:{
    width: "95%",
    borderRadius: 16,
  },

  containerImage:{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(2,0,0,0),
  },

}));


const findAddition = ( store, uid)=>{
  const addition=  store.additions.find(element => element.uid==uid); 
  return addition; 
}

const  getAdditions = (store,item)=>{
  let result = item.additions.map((uid)=>findAddition(store,uid)); 
  return result.filter(e => e); 
}


const isEnableAction =(additions,options)=>{
  let result =true; 
  additions.forEach(ad => {
    if(ad.type=="REQUIRED"){
      const selected = options.filter( opt=> opt.additionUid===ad.uid); 
      if(!selected || selected.length==0){
          result =false; 
      }
    }    
  });
  return result; 
}



export default function ItemPage(props) {
  const classes = useStyles();
  const {item,showCurrency, order,store, strings,onAddItemAdditions, onBack} = props; 

  const currency = store.currency; 
  const price = priceFormat(currency.style,item.price,showCurrency); 
  const [options, setOptions] = useState([]);
  const [additions, setAdditions] = useState(getAdditions(store,item));
  const [enableNext, setEnableNext] = useState(isEnableAction(additions,options)); 
  const [total, setTotal] = useState(priceFormat(currency.style,item.price,showCurrency)); 

  const orderList = order ? order.list : []; 
  //console.debug(`showCurrency, ${showCurrency}:`)

  const handlerBack = ()=>{
      onBack(); 
  }

  /**
   *  uid: 3661
   *  count: 1
      name: "Hamburguesa maxima"
      price: "1.3"
      type: "STANDARD"
      
   */
  const handlerAddFor = ()=>{
    let list = orderList;
    let orderItem = list.find( (it)=>it.uid===item.uid);

    if(!orderItem){
        orderItem = {
          uid: item.uid,
          count: 1,
          name: item.name, 
          price: item.price, 
          type: item.type,
          variants: [{
            key: getShortUuid(),
            options:options
          }]
        }
        list.push(orderItem);
    }else{
      orderItem.count+=1; 
      orderItem.variants.push({
        key: getShortUuid(),
        options:options
      }); 
      const index = list.indexOf(orderItem); 
      list[index]= orderItem; 
    }

    onAddItemAdditions(list); 
  }
  /**
   * 
   *const option =
        { 
          additionUid: undefined,
          optionUid:undefined,
          name:"name", 
          price:"price"
        } 
   */
  const handlerAdditionsChanges = (event, opt)=>{
    //console.debug(`handlerAdditionsChanges, ${event}:`, opt)
    let newList = [...options]; 
    if(event==='add'){
      newList.push(opt);
      //console.debug(`handlerAdditionsChanges, add `); 
      setOptions(newList); 
    }else if(event==='remove'){    
      const index =findIndexOption(newList,opt);
      //console.debug(`handlerAdditionsChanges, remove ${index}`); 
      if(index>=0)
        newList.splice(index,1);
      
      setOptions(newList); 
    }else if(event==='update'){
      const index =findIndexOption(newList,opt);
      //console.debug(`handlerAdditionsChanges, update ${index}`); 
      if(index>=0)
        newList[index] = opt;
     setOptions(newList); 
    }

    //console.debug(`handlerAdditionsChanges, newList:`, newList)

    newList.sort((a, b) => (a.additionUid > b.additionUid) ? 1 : -1); 
    setEnableNext(isEnableAction(additions,newList)); 
    setTotal(getTotalPriceString(newList));
  
  }

  const findIndexOption = (options,opt)=>{
    for(let index=0;index<options.length; index++){
      const element = options[index]; 
      if(element.uid == opt.uid && element.additionUid== opt.additionUid){
        return index; 
      }
    }
    return -1;
  }

  const getTotalPriceString=(listOptions)=>{
    let t=getTotalPriceVariant(item,listOptions); 
    const value = priceFormat(currency.style,t,showCurrency); 
    const addForStr= strings.additions_add_for.replace("${price}",value);
    return addForStr;
  }


  return (
    <div className = {classes.containerPage}>  
       <TopAppBar title = {item.name} />

      
       {item.image?
             <div  className={classes.containerImage}>
              <img className ={classes.imageItem} src={item.image} alt={"image"} />
             </div>
             :""
       }


      <div className = {classes.containerContent}>      
      
          <div className={classes.title}>  
                    <Typography variant="h4" color="textPrimary">
                        {item.name}
                    </Typography>
                    <Typography variant="h5" color="text.muted" mb={1}>
                        {price}
                    </Typography>

                    <Typography variant="body2" color="textSecondary">
                      {item.description}
                    </Typography> 
          </div>

          <div className = {classes.containerList}>
          {
             additions.map((ad)=>(
               ad.optionType == "COUNTER" ?  
               <AdditionCounter
               key={ad.uid}
               addition={ad}
               store= {store}
               strings={strings}
               showCurrency = {showCurrency}
               onChanges={handlerAdditionsChanges}
               />
              : 
              <Addition
              key={ad.uid}
              addition={ad}
              store= {store}
              showCurrency = {showCurrency}
              strings={strings}
              onChanges={handlerAdditionsChanges}
              />
            ))
          }
          </div>
    
        </div>

        <PanelButtons     
          labelCancel={strings.action_back}               
          labelNext={total}
          onClickCancel={handlerBack}
          onClickNext={handlerAddFor}
          nextDisabled={!enableNext}
          />   
    </div>
  );
}
